/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { type TivoPayloadAction } from '../../core/tivo/tivo-redux-wrapper';
import { TToastMessageState } from './toastmessage.actions';
import { TOAST_MESSAGE_CLEAR, TOAST_MESSAGE_HIDE, TOAST_MESSAGE_SHOW } from './toastmessage.types';

const initialState: TToastMessageState = {
    isVisible: false,
    message: '',
};

const toastMessageReducer = (
    state = initialState,
    { type, payload } = <TivoPayloadAction<TToastMessageState>>{},
) => {
    switch (type) {
        case TOAST_MESSAGE_CLEAR:
            return {
                ...state,
                message: payload.message,
            };

        case TOAST_MESSAGE_HIDE:
            return {
                ...state,
                isVisible: payload.isVisible,
            };

        case TOAST_MESSAGE_SHOW:
            return {
                ...state,
                isVisible: payload.isVisible,
                message: payload.message,
            };

        default:
            return state;
    }
};

export default toastMessageReducer;
